import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

interface Option {
  value: string | number;
  label: string;
}

interface MultiSelectProps {
  name: string;
  label: string;
  options: Option[];
  control: any;
  error?: string;
  helperText?: string;
  disabled?: boolean;
  required?: boolean;
  placeholder?: string;
  size?: 'small' | 'medium';
  freeSolo?: boolean;
}

const MultiSelect = ({ 
  name, 
  label, 
  options, 
  control, 
  error,
  helperText,
  disabled = false,
  required = false,
  placeholder,
  size = 'small',
  freeSolo = false
}: MultiSelectProps) => (
  <Controller
    name={name}
    control={control}
    defaultValue={[]}
    render={({ field, fieldState }) => (
      <Autocomplete
        multiple
        freeSolo={freeSolo}
        {...field}
        options={options}
        getOptionLabel={(option) => {
          if (typeof option === 'string') return option;
          return option?.label || '';
        }}
        isOptionEqualToValue={(option, value) => {
          if (!option || !value) return false;
          if (typeof value === 'object') {
            return option.value === value.value;
          }
          return option.value === value;
        }}
        value={field.value || []}
        onChange={(_, value) => {
          field.onChange(value);
        }}
        disabled={disabled}
        className="w-full"
        sx={{
          '& .MuiAutocomplete-tag': {
            color: '#000',
          },
          '& .MuiChip-deleteIcon': {
            fontSize: '14px !important',
            marginRight: '4px'
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            size={size}
            required={required}
            error={!!fieldState.error || !!error}
            helperText={fieldState.error?.message || error || helperText}
            placeholder={placeholder}
          />
        )}
        filterOptions={(options, params) => {
          const filtered = options.filter((option) => {
            if (!option) return false;
            const label = typeof option === 'string' ? option : option.label;
            return label?.toLowerCase().includes(params.inputValue.toLowerCase());
          });
          
          const { inputValue } = params;
          if (!inputValue) return filtered;

          const isExisting = filtered.some((option) => {
            if (!option) return false;
            const label = typeof option === 'string' ? option : option.label;
            return label?.toLowerCase() === inputValue.toLowerCase();
          });
          
          if (!isExisting && freeSolo) {
            filtered.push(inputValue);
          }
          
          return filtered;
        }}
      />
    )}
  />
);

export default MultiSelect; 